/* FRK: pictures inside things that start hidden (the search popup, the brand hover cards) are written as
   <img data-frk-src="..."> with a 1px placeholder, so the browser does not download them on first paint.
   They are filled in when the thing is first used: the search popup opening, or a pointer / keyboard / touch
   reaching the brand tiles. Without JavaScript they simply stay empty (they are hidden anyway). */
(() => {
  'use strict';
  if (window.__frkLazyHidden) return;
  window.__frkLazyHidden = true;

  const hydrate = (scope) => {
    (scope || document).querySelectorAll('img[data-frk-src]').forEach((img) => {
      img.src = img.getAttribute('data-frk-src');
      img.removeAttribute('data-frk-src');
    });
  };

  // Search popup: the theme removes its inline visibility:hidden when it opens
  const popup = document.querySelector('[data-search-popup]');
  if (popup && 'MutationObserver' in window) {
    const mo = new MutationObserver(() => {
      if (popup.style.visibility !== 'hidden') { mo.disconnect(); hydrate(popup); }
    });
    mo.observe(popup, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  // Brand tiles: hover cards open on pointer, keyboard focus or touch
  document.querySelectorAll('[data-grp-bflip]').forEach((grid) => {
    const go = () => hydrate(grid);
    ['pointerenter', 'focusin', 'touchstart'].forEach((ev) => grid.addEventListener(ev, go, { once: true, passive: true }));
  });
})();
